import { faItunesNote } from '@fortawesome/free-brands-svg-icons'
import { faShareNodes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import dynamic from 'next/dynamic'
import { useState } from 'react'
import { t } from '../../../../../utils'
import { songPath } from '../../../../../utils/routeHelpers'
import { Song } from '../../../../../__generated__/graphql'
import styles from './_storeSongActions.module.scss'
import { ReactSVG } from 'react-svg'

const SocialShareLinks = dynamic(() => import('./SocialShareLinks'))

const StoreSongActions: React.FC<{ song: Song }> = ({ song }) => {
  const [socialLinksOpen, setSocialLinksOpen] = useState(false)
  return (
    <ul className={styles.storeSongActions}>
      <li>
        <a href={songPath(song)} className={styles.storeSongActionLink}>
          <ReactSVG
            className={styles.playButton}
            src={'../../images/store/play-button.svg'}
          />
          <div>{t('Tutorial')}</div>
        </a>
      </li>
      <li>
        <a
          href={song.appleMusicUrl}
          target="_blank"
          rel="noreferrer"
          className={styles.storeSongActionLink}
        >
          <FontAwesomeIcon size="lg" icon={faItunesNote} />
          <div>{t('iTunes')}</div>
        </a>
      </li>
      <li>
        <a
          onClick={() => setSocialLinksOpen(!socialLinksOpen)}
          className={styles.storeSongActionLink}
        >
          <FontAwesomeIcon size="lg" icon={faShareNodes} />
          <div>{t('Share')}</div>
        </a>
        {socialLinksOpen && (
          <SocialShareLinks
            title={song.title}
            url={`https://app.worshiponline.com/store/songs/${song.id}`}
          />
        )}
      </li>
    </ul>
  )
}

export default StoreSongActions
